import React from 'react';
import { isNewUIEnabled } from 'hooks/useNewUI';
import UploadPanelNew from './UploadPanelNew';
import UploadPanelClassic from './UploadPanelClassic';

// The upload progress popup is shown (gated by UPLOAD_CONFIG) for everyone, but
// only allow-listed new-UI users should see the frosted glassmorphism restyle.
// Classic (production) users keep the legacy upload panel look.
const UploadPanel = (props) => (isNewUIEnabled()
  ? <UploadPanelNew {...props} />
  : <UploadPanelClassic {...props} />);

export default UploadPanel;
